import React, { useState, useRef, useEffect } from 'react'
import Parser from 'html-react-parser';
// import PropTypes from 'prop-types'
import { v4 as uuid } from 'uuid'
import useWindowSize from '../../../../Hooks/useWindowSize'

// Mol
import Modal, { ModalSize } from '../../Modal'
import MServiceHomePartModal from '../../Modal/Part/MServiceHome'
import MSolicitarPartModal from '../../Modal/Part/MSolicitar'
import MModCompraPartModal from '../../Modal/Part/MModCompra'

import InputSelect, { InputSelectType } from '../../../Atoms/InputSelect'
import 'lazysizes';
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

function General2PlanCardMol(props) {
    const {
        title,
		titlestyle,
		name,
		changeCompare,
		fi_PLAN,
		fi_ID_TELEFONIA,
		fi_ID_TELEVISION,
		fi_ID_INTERNET,
        fc_DESCRIPCION_INTERNET,
        fc_DESCRIPCION_TELEVISION,
        fc_DESCRIPCION_TELEFONIA,
		fi_CATEGORIA,
        fi_SERVICIO,
		// fc_TIPO_DISPONIBILIDAD,
		// fc_TEXTO_CAJA,
		// fc_COLOR_CAJA,
		// fc_NOMBRE,
		fc_DESCRIPCION,
		fi_NUMERO_CARACTERISTICAS_MOSTRAR,
		// fc_TITULO_CARACTERISTICAS_AGRUPADAS,
		fi_PRECIO_PLAN,
		// fi_PRECIO_TELEFONIA_ENPS,
		// fi_PRECIO_TELEVISION_ESPN,
		// fi_PRECIO_INTERNET_ESPS,
		// fc_COLOR_PRECIO,
        fi_PRECIO_TELEFONIA,
		fi_PRECIO_TELEVISION,
		fi_PRECIO_INTERNET,
		fc_ETIQUETA_PRECIO_TACHADO,
		fc_PRECIO_TACHADO,
		fc_NOTA_DEBAJO_PRECIO,
		fc_TEXTO_DETALLE,
		fc_URL_DETALLE,
		fc_TARGET_DETALLE,
		// fi_BAN_DETALLE,
		fc_OPCION_CONTRATACION,
		fc_TEXTO_CONTRATAR,
		fc_URL_CONTRATAR,
		fc_TARGET_CONTRATAR,
		// fi_BAN_CONTRATAR,
		// fi_ORDEN,
		// fi_ACTIVO,
		fi_ID_DASHBOARD,
		// fi_BAN_ENPN,
		// fi_BAN_ENPS,
		// fi_BAN_ESPN,
		// fi_BAN_ESPS,
		// fc_ETIQUETA_PROMOCION_ATP,
		// fi_PRECIO_AHORRO,
		fc_ETIQUETA_PERIODO,
		Caracteristicas,
		Acordeon,
        dataGenAccordion,
		keysPlanCompare,
		lstPlanContratacionxPlan,
        Discount,
		filterPostPago,
		postPagoCarac,
		Estrato,
		Dane,
		fc_NOTA_DETALLE_PROMOCION,
		fc_DURACION,
        fc_PLAN_ICONO,
        fc_TITULO_PROMO,
        caracteristicasPromocion,
        fc_DESCRIPCION_OFERTA,
        fc_CRC,
        fi_INCLUIR_SECCION,
        fc_ETIQUETA_ROJA,
        fc_TITULO_SECCION,
        fc_DESCRIPCION_SECCION,
        fc_URL_BOTON,
        fc_TARGET_BOTON,
        fc_TEXTO_BOTON,
        optionsCiudadesLogic,
        fc_TECNOLOGIA_TELEVISION,
        fc_TECNOLOGIA_INTERNET,
        telefonia,
        television,
        internet,
        //ciudad,
        precioCombo
    } = props

    const relAttribute = fc_TARGET_CONTRATAR == "_blank" ? "noopener": "";

    /*const searchPlanContratacion = (search, lstPlanContratacionxPlan) => {
        console.log("lstPlanContratacionxPlan", lstPlanContratacionxPlan)
        const data = lstPlanContratacionxPlan?.length ? lstPlanContratacionxPlan : [];
        const newCaractData = data.find(function (PlanContra) {
            let lstPlan = []

            lstPlan = PlanContra.fc_OPCION_LBX
            // console.log("to search---------- TypeFlag:", lstPlan, search)
            return lstPlan === search
        })
        // console.log("to search---------- TypeFlag:", TypeFlag, search, newCaractData, newCaractData.length)
        return newCaractData

    }*/

    //let PlanContratacionCAL = searchPlanContratacion('CAL', lstPlanContratacionxPlan)
    //let urlContr = `https://backoffice-ng.amx-dev.clarodigital.net/wps/portal/co/pcc/personas/app/solicitudes/solicitud-producto-hogar/?prod=${PlanContratacionCAL?.fc_NOMBRE_CAMPANIA}&ciudad=${ciudad}&formId=1&canal_trafico=ORGANICO`

    
    let newAcordeon = Acordeon.map((item, index) => {
        if (!item?.open) {
            item.open = false
        }
        return item;
    })

    const cardPricesRef = useRef()

    const {
        // height: heightWindow,
        width: widthWindow,
    } = useWindowSize()

    const ajustarCard = function (className) {
        var altura, i, maxHeight, total;
        var els = document.getElementsByClassName(className)

        // Limpia todos los height
        Array.prototype.forEach.call(els, function (el) {
            el.style.height = ''
        });

        // Se optienen todos los height
        altura = [];
        total = els.length - 1
        i = 0;
        while (i <= total) {
            altura.push(els[i].offsetHeight);
            i++;
        }
        // Se optiene la height maxima entre todas las tarjetas
        maxHeight = Math.max.apply(null, altura);

        // Se aplica a todos la height
        Array.prototype.forEach.call(els, function (el) {
            // console.log(el.offsetHeight);
            el.style.height = maxHeight + 'px'
        });
    }

    // ajusta siempre que cambia
    useEffect(() => {
        ajustarCard('cPlanV2Head')
        ajustarCard('cPlanV2Prices')
        ajustarCard('cPlanV2Promo')
        ajustarCard('cPlanV2ContentDetails')

    })

    useEffect(() => {
        ajustarCard('cPlanV2Head')
        ajustarCard('cPlanV2Prices')
        ajustarCard('cPlanV2Promo')
        ajustarCard('cPlanV2ContentDetails')
    }, [widthWindow])

    const modalServiceRef = useRef()
    // const modalRequestRef = useRef()
    const modalModCompraRef = useRef()
    const openModalService = () => modalServiceRef.current.open()
    // const openModalRequest = () => modalRequestRef.current.open()
    const openModalModCompra = () => modalModCompraRef.current.open()
    // const closeModalModCompra = () => modalModCompraRef.current.close()

    const onClickSeeMore = () => {
        console.log('Conoce más')
        openModalService()
    }
    const onClickRequest = () => {
        console.log('Contratar')
        openModalModCompra()
    }

    const toChecked = keysPlanCompare.filter(function (keyData) {
        if (keyData === fi_PLAN) {
            return true
        } else {
            return false
        }
    })

    const searchCharacteristics = (search, TypeFlag = false, Caracteristicas, filterPostPago = null, fi_PLAN) => {
		
        if (TypeFlag) {
			const data = Caracteristicas?.length ? Caracteristicas : [];
			const newCaractData = data.filter(function (CaracData) {
				let CaracDESCRIPCION = [], idWS = 0

				CaracDESCRIPCION = CaracData.fc_DESCRIPCION
                
				idWS = CaracData.fi_CARACTERISTICA_WS.toString()
                
                let newCaracToShowTitle = postPagoCarac.find((element)=>{return element.fc_CARACTERISTICA_WS === idWS})
                if (filterPostPago && id_familia !== 'SHO'){
                    if (newCaracToShowTitle !== undefined){
                        CaracData.fc_TITULO = newCaracToShowTitle.fc_TEXTO_MOSTRAR
                        CaracData.fi_MOSTRAR_CRC = CaracData.fc_VALOR === "" ? 0 : newCaracToShowTitle.fi_MOSTRAR_CRC
                        CaracData.fc_CLASE_CRC = newCaracToShowTitle.fc_CLASE_CRC
                        CaracData.fc_CLASE_GENERAL_CRC = newCaracToShowTitle.fc_CLASE_GENERAL_CRC
                    }
                    return CaracDESCRIPCION.indexOf(search) > -1 && newCaracToShowTitle !== undefined
                }else{
                    return CaracDESCRIPCION.indexOf(search) > -1
                }
			})
            let dataToCarac = newCaractData.filter(f => (f.fi_MOSTRAR_CRC !== 0));
            let dataToNoCarac = newCaractData.filter(f => (f.fi_MOSTRAR_CRC === 0));
            let CaracDataConcat = []
            CaracDataConcat = dataToCarac.concat(dataToNoCarac)
			// console.log("to search---------- TypeFlag true: fi_PLAN", fi_PLAN, TypeFlag, search, CaracDataConcat)
			return CaracDataConcat
		} else {
			const data = Caracteristicas?.length ? Caracteristicas : [];
			const newCaractData = data.filter(function (CaracData) {
				let CaracDESCRIPCION = [], idWS = 0

				CaracDESCRIPCION = CaracData.fc_DESCRIPCION
				idWS = CaracData?.fi_CARACTERISTICA_WS.toString()
                if ( idWS === "0" ){
                    // console.log("idWS:", idWS)
                    return CaracDESCRIPCION.indexOf(search) === -1
                }else{
                    let newCaracToShowTitle = postPagoCarac.find((element)=>{return element.fc_CARACTERISTICA_WS === idWS})

                    if (filterPostPago && id_familia !== 'SHO'){
                        if (newCaracToShowTitle !== undefined){
                            CaracData.fc_TITULO = newCaracToShowTitle.fc_TEXTO_MOSTRAR
                            CaracData.fi_MOSTRAR_CRC = CaracData.fc_VALOR === "" ? 0 : newCaracToShowTitle.fi_MOSTRAR_CRC
                            CaracData.fc_CLASE_CRC = newCaracToShowTitle.fc_CLASE_CRC
                            CaracData.fc_CLASE_GENERAL_CRC = newCaracToShowTitle.fc_CLASE_GENERAL_CRC
                        }
                        return CaracDESCRIPCION.indexOf(search) === -1 && newCaracToShowTitle !== undefined
                    }else{
                        return CaracDESCRIPCION.indexOf(search) === -1
                    }
                }
			})
            let dataToCarac = newCaractData.filter(f => (f.fi_MOSTRAR_CRC !== 0));
            let dataToNoCarac = newCaractData.filter(f => (f.fi_MOSTRAR_CRC === 0));
            let CaracDataConcat = []
            CaracDataConcat = dataToCarac.concat(dataToNoCarac)
			// console.log("to search---------- TypeFlag false: fi_PLAN", fi_PLAN, TypeFlag, search, CaracDataConcat)
			return CaracDataConcat
		}
	}
    const getuniqueCaracteristicas = (Caracteristicas, fi_PLAN) => {
        let data = Caracteristicas?.length ? Caracteristicas : [];
        // console.log("getuniqueCaracteristicas fi_PLAN", fi_PLAN, data)
        let uniqueCaract = [];
        Caracteristicas.forEach((element) => {
            if (element.fi_CARACTERISTICA_WS !== "" && element.fi_CARACTERISTICA_WS > 0 ){
                if (!uniqueCaract.includes(element)) {
                    if (uniqueCaract.length === 0){
                        uniqueCaract.push(element);
                    }else if(!uniqueCaract.find((itemC)=>{return itemC.fi_CARACTERISTICA_WS === element.fi_CARACTERISTICA_WS})){
                        uniqueCaract.push(element);
                    }
                }
            }else{
                uniqueCaract.push(element);
            }
        });
        // console.log("uniqueCaract fi_PLAN", fi_PLAN, uniqueCaract, Caracteristicas)
        if (data.length !== uniqueCaract.length){
            data = uniqueCaract
        }
        return data
    }
    const [detailsCond, setDetailsCond] = useState(false)
    let uniqueCaracteristicas = getuniqueCaracteristicas(Caracteristicas, fi_PLAN);
    let id_familia = localStorage.getItem('id_familia')
    let CharactBlock = searchCharacteristics('Tipo Footer', false, uniqueCaracteristicas, filterPostPago, fi_PLAN)
	let CharactFooter = searchCharacteristics('Tipo Footer', true, uniqueCaracteristicas, filterPostPago, fi_PLAN)
    
    // console.log("searchCharacteristics fi_PLAN:", fi_PLAN, CharactBlock, CharactFooter)
    const symbolPrice = id_familia === "SHO"  ? "$" : "$";

     let URL_CONTRATAR ="";

    if(fi_PLAN===441){
        URL_CONTRATAR ="https://tienda.claro.com.co/claro/pasate-de-prepago-a-postpago-claro?utm_source=clarocolombia&utm_medium=referral&utm_campaign=pos_mig_nuevo_feb_eng_pef&utm_content=nuevo_feb_cards_planes&utm_term=fst_pef&utm_creative_format=btn"
         console.log("el fi plan es 441");
    } else if(fi_PLAN===443 || fi_PLAN===439){
        URL_CONTRATAR ="https://api.whatsapp.com/send?phone=3112000000&text=Disfruta%20la%20experiencia%20de%20ser%20parte%20de%20la%20familia%20Claro%20con%20tu%20Plan%20Postpago"
         console.log("el fi plan es 439");
    }
    return (
        <>
            <div dane={Dane ? Dane : null} estrato={id_familia !== "SMO" ? Estrato : null}  duracion={fc_DURACION ? fc_DURACION : null }></div>
            <div className={`initTel ${telefonia ? 'telefonia' : ''}`}>
                <div className={`initTv ${television ? 'television' : ''}`} tecnologia={fc_TECNOLOGIA_TELEVISION ? fc_TECNOLOGIA_TELEVISION : null}>
                    <div className={(internet ? 'internet' : '') + ' cPlanV2Wrap ' + (titlestyle ? titlestyle : 'amarillo')} tecnologia={fc_TECNOLOGIA_INTERNET ? fc_TECNOLOGIA_INTERNET : null} >
                        <div className="cPlanV2">
                            {
                                title
                                    ?
                                    <div className="cPlanV2Flag">
                                        <p>{title}</p>
                                    </div>
                                    :
                                    null
                            }
                            <div className="cPlanV2Head">
                                <div className="cPlanV2Icon">
                                    {
                                        fc_PLAN_ICONO
                                            ?
                                            <i className={fc_PLAN_ICONO}></i>
                                            : null
                                    }
                                </div>
                                <div className="cPlanV2HeadCont">
                                    <h3 className="h3 titulo">{name}</h3>
                                    <div className="cPlanV2HeadInf">
                                        {/* <p>{name}</p> */}
                                        {
                                            fc_DESCRIPCION ?
                                                <p>
                                                    {fc_DESCRIPCION}
                                                </p>
                                                : null
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="cPlanV2Prices" ref={cardPricesRef}>
                                <div className="cPlanV2PricesTime">
                                    {/* <p>mensual por 11 meses</p> */}
                                    {
                                        fc_ETIQUETA_PERIODO ?
                                            <p>
                                                {fc_ETIQUETA_PERIODO}
                                            </p>
                                            : null
                                    }
                                </div>
                                <div className="cPlanV2PricesPrice">
                                    {/* <p>$25.990</p> */}
                                    {
                                        fi_PRECIO_PLAN ?
                                            <p>
                                                <span className="symbol"> {symbolPrice}</span>
                                                <span className="valor-numerico cPrice">{fi_PRECIO_PLAN}</span>
                                            </p>
                                            : null
                                    }
                                </div>
                                <div className="cPlanV2PricesTitle">
                                    {
                                        fc_DESCRIPCION_OFERTA
                                            ?
                                            <p>{fc_DESCRIPCION_OFERTA}</p>

                                            : null
                                    }
                                </div>
                                <div className="cPlanV2PricesNote">
                                    {/* <p>cargo fijo normal: <del>$37.990</del> mensual</p> */}
                                    {
                                        fc_ETIQUETA_PRECIO_TACHADO && fc_PRECIO_TACHADO ?

                                            <p>{fc_ETIQUETA_PRECIO_TACHADO}: {symbolPrice} <del>{fc_PRECIO_TACHADO}</del></p>

                                            : null
                                    }
                                </div>

                                {
                                    fc_NOTA_DEBAJO_PRECIO ?
                                        <div className="cPlanV2PricesPlaque leyend">
                                            <p>{Parser(String(fc_NOTA_DEBAJO_PRECIO))}</p>
                                        </div>
                                        : null
                                }
                                {
                                    Discount != null ?
                                        <div className="cPlanV2Tag">
                                            <picture>
                                                <source media="(max-width: 640px)" data-srcset="/portal/co/recursos_tema/assets/img/cardPlanV2Disc.webp" type="image/webp" />
                                                <source media="(max-width: 640px)" data-srcset="/portal/co/recursos_tema/assets/img/cardPlanV2Disc.png" type="image/jpeg" />
                                                <source media="(min-width: 640px)" data-srcset="/portal/co/recursos_tema/assets/img/cardPlanV2Disc.webp" type="image/webp" />
                                                <source media="(min-width: 640px)" data-srcset="/portal/co/recursos_tema/assets/img/cardPlanV2Disc.png" type="image/jpeg" />
                                                <img className="lazyload" data-src="/portal/co/recursos_tema/assets/img/cardPlanV2Disc.png" alt="" width="100" height="55" />
                                            </picture>

                                            <div className='cPlanV2TagCont'>
                                                <div className="cPlanV2TagNumber">
                                                    <p>{Discount}</p>
                                                </div>
                                                <div className='cPlanV2TagPor'>
                                                    <p className='disc'>%</p>
                                                    <p className='note'>DCTO</p>
                                                </div>
                                            </div>

                                        </div>
                                        :
                                        <div className="cPlanV2Tag"></div>
                                }

                            </div>
                            {
                                fc_TITULO_PROMO || caracteristicasPromocion?.length
                                    ?
                                    <div className="cPlanV2Promo">
                                        <p>{fc_TITULO_PROMO ? fc_TITULO_PROMO : null}</p>
                                        <div className="cPlanV2PromoItems">
                                            {
                                                caracteristicasPromocion?.length
                                                    ?
                                                    caracteristicasPromocion.map((caract, index) => (
                                                        caract?.fc_TIPO_VALOR_CARACTERISTICA?.includes("IMG") ?
                                                            <picture key={uuid()}>
                                                                <source media="(max-width: 640px)" data-srcset={caract?.fc_VALOR.split(".")[0] + ".webp"} type="image/webp" />
                                                                <source media="(max-width: 640px)" data-srcset={caract?.fc_VALOR} type={"image/" + caract?.fc_VALOR.split(".")[1]} />
                                                                <source media="(min-width: 640px)" data-srcset={caract?.fc_VALOR.split(".")[0] + ".webp"} type="image/webp" />
                                                                <source media="(min-width: 640px)" data-srcset={caract?.fc_VALOR} type={"image/" + caract?.fc_VALOR.split(".")[1]} />
                                                                <img className="lazyload" data-src={caract?.fc_VALOR} alt={caract?.fc_ALT_IMG} width="75" height="25" />
                                                            </picture>
                                                            :
                                                            <i key={uuid()} className={caract?.fc_VALOR}></i>
                                                    ))
                                                    : null
                                            }
                                        </div>
                                    </div>
                                    : null
                            }
                            <div className={`cPlanV2Content cPlanV2ContentMore ${detailsCond ? 'openDetails' : ''}`}>
                                <div className="cPlanV2ContentOpen" onClick={() => { setDetailsCond(c => !c) }}>
                                    <p>{`Ver detalle ${fi_CATEGORIA === 11 || fi_CATEGORIA === 12 ? 'del paquete' : 'de plan' }`}</p>
                                    <i className="ico-chevron-down"></i>
                                </div>

                                <div className="cPlanV2ContentDetails">
                                    {fi_ID_INTERNET > 0 && fi_PRECIO_INTERNET > 0 &&
                                        <dl classname="carac-plan cPlanV2DL iconEle">
                                            <dt>
                                                <i className="ico-globe"></i>
                                                <span>Internet</span>
                                            </dt>
                                            <dd>
                                                {fc_DESCRIPCION_INTERNET}
                                                <span className="ddExtra">Precio unitario: {fi_PRECIO_INTERNET}</span>
                                            </dd>
                                        </dl>
                                    }
                                    {fi_ID_TELEFONIA > 0 && fi_PRECIO_TELEFONIA > 0 &&
                                        <dl className="carac-plan cPlanV2DL iconEle">
                                            <dt>
                                                <i className="ico-smartphone"></i>
                                                <span>Telefon&iacute;a</span>
                                            </dt>
                                            <dd>
                                                {fc_DESCRIPCION_TELEFONIA}
                                                <span className="ddExtra">Precio unitario: {fi_PRECIO_TELEFONIA}</span>
                                            </dd>
                                        </dl>
                                    }
                                    {fi_ID_TELEVISION > 0 && fi_PRECIO_TELEVISION > 0 &&
                                        <dl className="carac-plan cPlanV2DL iconEle">
                                            <dt>
                                                <i className="ico-tv"></i>
                                                <span>Televisi&oacute;n</span>
                                            </dt>
                                            <dd>
                                                {fc_DESCRIPCION_TELEVISION}
                                                <span className="ddExtra">Precio unitario: {fi_PRECIO_TELEVISION}</span>
                                            </dd>
                                        </dl>
                                    }
                                    {
                                        CharactBlock ?
                                            CharactBlock
                                            .filter(caract =>!(
                                                        caract.fc_VALOR === "Gigas Ilimitadas" &&
                                                        (fi_PLAN === 280 || fi_PLAN === 279)
                                                    )
                                                    ).map((caract, index) => (
                                                       caract.fc_VALOR.includes("logo") ?
                                                        <dl key={uuid()} className={`${caract?.fc_CLASE_GENERAL_CRC ? caract.fc_CLASE_GENERAL_CRC : 'carac-plan'} cPlanV2DL`} style={(caract.fi_MOSTRAR_CRC === 0 || (index + 1) > fi_NUMERO_CARACTERISTICAS_MOSTRAR) ?{display:'none'} :(fi_ID_INTERNET > 0 || fi_ID_TELEVISION > 0 || fi_ID_TELEFONIA > 0) ? {display:''} : {}}>

                                                        <dt>
                                                            
                                                            <span className={`${caract.fc_VALOR}`}></span>
                                                        </dt>
                                                        <dd>{caract.fc_TITULO}</dd>
                                                    </dl>
                                                    :
                                                    <dl key={uuid()} className={`${caract?.fc_CLASE_GENERAL_CRC ? caract.fc_CLASE_GENERAL_CRC : 'carac-plan'} cPlanV2DL ${caract.fc_CLASE_ICONO && !caract.fc_DESCRIPCION.includes("Redes Sociales") ? 'iconEle' : ''}`} style={(caract.fi_MOSTRAR_CRC === 0 || (index + 1) > fi_NUMERO_CARACTERISTICAS_MOSTRAR) ?{display:'none'} :(fi_ID_INTERNET > 0 || fi_ID_TELEVISION > 0 || fi_ID_TELEFONIA > 0) ? {display:''} : {}}>

                                                        {
                                                            caract.fc_CLASE_ICONO
                                                                ?
                                                                <dt>
                                                                    {
                                                                        caract.fc_DESCRIPCION.includes("Redes Sociales")
                                                                            ? null
                                                                            :<i className={caract.fc_CLASE_ICONO}></i>
                                                                    }
                                                                    <span>{caract.fc_TITULO}</span>
                                                                </dt>
                                                                :
                                                                <dt>
                                                                    {caract.fc_TITULO}
                                                                </dt>
                                                        }

                                                        {
                                                            caract.fc_DESCRIPCION.includes("Redes Sociales")
                                                                ?
                                                                <dd className={`${caract?.fc_CLASE_CRC ? caract.fc_CLASE_CRC : ''} cPlanRedS`}>
                                                                    <ul>
                                                                        {
                                                                            caract.fc_VALOR.split("|").map((icoRed, index) => (
                                                                                <li key={uuid()}>
                                                                                    <span>
                                                                                        <i className={icoRed} />
                                                                                    </span>
                                                                                </li>
                                                                            ))
                                                                        }
                                                                    </ul>
                                                                </dd>
                                                                :
                                                                <dd className={`${caract?.fc_CLASE_CRC ? caract.fc_CLASE_CRC : ''}`}>{caract.fc_VALOR}</dd>
                                                        }
                                                    </dl>
                                            ))

                                            : null
                                    }
                                    {
                                        CharactFooter ?
                                            CharactFooter.map((caract, index) => (
                                                <div key={uuid()} className={`${caract?.fc_CLASE_GENERAL_CRC ? caract.fc_CLASE_GENERAL_CRC : ''} cPlanIconBlock`} style={(caract.fi_MOSTRAR_CRC === 0 || (index + 1) > fi_NUMERO_CARACTERISTICAS_MOSTRAR) ?{display:'none'} : (fi_ID_INTERNET > 0 || fi_ID_TELEVISION > 0 || fi_ID_TELEFONIA > 0) ? {display:''} : {}}>
                                                    <span className="iconCircle">
                                                        {
                                                            caract.fc_CLASE_ICONO ?
                                                                <i className={caract.fc_CLASE_ICONO}></i>
                                                                : null
                                                        }

                                                    </span>
                                                    <p>
                                                        <strong> {caract.fc_TITULO}</strong>
                                                        <span> {caract.fc_VALOR}</span>
                                                    </p>
                                                </div>
                                            ))
                                            : null
                                    }
                                    {(fi_ID_INTERNET > 0 
                                        || fi_ID_TELEVISION > 0 
                                        || fi_ID_TELEFONIA > 0) && precioCombo >0 &&
                                        <dl className="cPlanV2DL totalPrice">
                                            <dt>
                                                Precio total
                                            </dt> 
                                            <dd>
                                                {precioCombo}
                                            </dd> 
                                        </dl>
                                    }
                                    
                                    <dl className="cPlanV2DL">
                                        
                                        <div className="cPlanV2DLAction">
                                            {
                                                
                                                fc_TEXTO_DETALLE &&
                                                    (fc_URL_DETALLE !== "$URL_DEFAULT_DETALLE$"
                                                        ?
                                                    <a href={fc_URL_DETALLE} target={fc_TARGET_DETALLE ? fc_TARGET_DETALLE : "_self"} dangerouslySetInnerHTML={{ __html: fc_TEXTO_DETALLE }}/>:
                                                    <a href="#!" target={fc_TARGET_DETALLE ? fc_TARGET_DETALLE : "_self"} onClick={() => onClickSeeMore()} dangerouslySetInnerHTML={{ __html: fc_TEXTO_DETALLE }}/>
                                                    )
                                            }
                                        </div>
                                    </dl>
                                </div>

                                <div className="cPlanV2ContentClose" onClick={() => { setDetailsCond(c => !c) }}>
                                    <p>Ocultar</p>
                                    <i className="ico-chevron-up"></i>
                                </div>
                            </div>
<div className="cPlanV2Actions">
{
    fc_TEXTO_CONTRATAR ? (
        fc_OPCION_CONTRATACION === "URL" ? (
            <a
                className="btn btnPrimario"
                href={
                    URL_CONTRATAR===""
                    ?
                    (fi_PLAN === 448 || fi_PLAN === 453 || fi_PLAN === 450)
                         ? "https://api.whatsapp.com/send?phone=573112000000&text=Listo%20para%20activar%20mi%20l%C3%ADnea%20pospago"
                    // Si el plan es 280 o 372 → usa el link de bit.ly
                    :(fi_PLAN === 280 || fi_PLAN === 372)
                        ? "https://bit.ly/4eNE2tD"
                        :fi_PLAN === 440 ? "https://tienda.claro.com.co/claro/pasate-de-prepago-a-postpago-claro?utm_source=clarocolombia&utm_medium=referral&utm_campaign=pos_mig_cards_planes_eng_pef&utm_content=cards_planes_75gb&utm_term=fst_pef&utm_creative_format=lin"
                        :fi_PLAN === 374 ? "https://tienda.claro.com.co/claro/pasate-de-prepago-a-postpago-claro?utm_source=claro&utm_medium=referral&utm_campaign=pos_mig_cc_awn&utm_content=cc_card&utm_term=fst&utm_creative_format=crd&utm_marketing_tactic=awn"
                        // Si la categoría es 11 o 3 y no es 280/372 → usa WhatsApp
                        : (fi_CATEGORIA === "11" || fi_CATEGORIA == "3")
                            ? "https://api.whatsapp.com/send?phone=573112000000&text=Deseo%20tener%20mi%20plan%20pospago"
                            // En cualquier otro caso → usa la URL por defecto
                            : fc_URL_CONTRATAR
                    :URL_CONTRATAR
                }
                target={fc_TARGET_CONTRATAR ? fc_TARGET_CONTRATAR : "_self"}
                rel={relAttribute}
            >
                {
                    fc_CRC === "postpago" || fc_CRC === "pospago"
                        ? "Contratar"
                        : fc_TEXTO_CONTRATAR.replace("Ã¡", "á")
                }
            </a>
        ) : (
            <a
                className="btn btnPrimario"
                href="#!"
                onClick={() => onClickRequest()}
                target="_self"
            >
                {
                    fc_CRC === "postpago" || fc_CRC === "pospago"
                        ? "Contratar"
                        : fc_TEXTO_CONTRATAR.replace("Ã¡", "á")
                }
            </a>
        )
    ) : null
}
</div>






                            {
                                changeCompare
                                    ?
                                    <div className='cPlanV2Compare'>

                                        <InputSelect
                                            type={InputSelectType.CHECKBOX}
                                            onChange={changeCompare}
                                            name={fi_PLAN}
                                            checked={toChecked.length ? true : false}
                                            disabled={keysPlanCompare.length >= 5 && !toChecked.length ? true : false}
                                        >
                                            Comparar
                                        </InputSelect>
                                    </div>
                                    : null

                            }
                        </div>
                        {
                            fi_INCLUIR_SECCION === 1
                                ?
                                <div className="cPlanV2Offer cPlanV2OfferShow">
                                    <p className="cPlanV2OfferLeft">{fc_ETIQUETA_ROJA}</p>
                                    <div className="cPlanV2OfferCont">
                                        <p>{fc_TITULO_SECCION}</p>
                                        <p>{fc_DESCRIPCION_SECCION}</p>
                                        { fc_TEXTO_BOTON &&
                                            <div className="cPlanV2OfferAction">
                                                <a href={fc_URL_BOTON} target={fc_TARGET_BOTON ? fc_TARGET_BOTON : '_self'}>
                                                    {fc_TEXTO_BOTON}
                                                    <i className="ico-chevron-right"></i>
                                                </a>
                                            </div>
                                        }
                                    </div>
                                </div>
                                : null
                        }
                    </div>
                </div>
            </div>
            <Modal
                ref={modalServiceRef}
                size={ModalSize.MEDIUM_2}
            >
                <MServiceHomePartModal
                    asks={newAcordeon}
                    Caracteristicas={uniqueCaracteristicas}
                    // Caracteristicas={Caracteristicas}
                    title={title}
                    name={name}
                    fc_DESCRIPCION={fc_DESCRIPCION}
                    fi_PRECIO_PLAN={fi_PRECIO_PLAN}
                    fc_ETIQUETA_PERIODO={fc_ETIQUETA_PERIODO}
                    titlestyle={titlestyle}
                    fc_TITULO_PROMO={fc_TITULO_PROMO}
                    caracteristicasPromocion={caracteristicasPromocion}
                    fc_NOTA_DETALLE_PROMOCION={fc_NOTA_DETALLE_PROMOCION}
                    fi_ID_DASHBOARD={fi_ID_DASHBOARD}
                    dataGenAccordion={dataGenAccordion}
                    symbolPrice={symbolPrice}
                    fi_PLAN={fi_PLAN}
                />
            </Modal>
            {
                fc_OPCION_CONTRATACION === "REN"
                    ?
                    <Modal
                        ref={modalModCompraRef}
                        size={ModalSize.MEDIUM_3}
                    >
                        <MModCompraPartModal
                            title={title}
                            name={name}
                            fc_DESCRIPCION={fc_DESCRIPCION}
                            fi_PRECIO_PLAN={fi_PRECIO_PLAN}
                            fc_ETIQUETA_PERIODO={fc_ETIQUETA_PERIODO}
                            fc_DESCRIPCION_OFERTA={fc_DESCRIPCION_OFERTA}
                            lstPlanContratacionxPlan={lstPlanContratacionxPlan}
                            symbolPrice={symbolPrice}
                            Caracteristicas={Caracteristicas}
                            fc_TITULO_PROMO={fc_TITULO_PROMO}
                            caracteristicasPromocion={caracteristicasPromocion}
                        />
                    </Modal>
                    :
                    <Modal
                        ref={modalModCompraRef}
                        size={ModalSize.SMALL}
                    >
                        <MSolicitarPartModal
                            title={title}
                            name={name}
                            fc_DESCRIPCION={fc_DESCRIPCION}
                            fi_PRECIO_PLAN={fi_PRECIO_PLAN}
                            fc_ETIQUETA_PERIODO={fc_ETIQUETA_PERIODO}
                            lstPlanContratacionxPlan={lstPlanContratacionxPlan}
                            Caracteristicas={Caracteristicas}
                            optionsCiudades={optionsCiudadesLogic}
                            fi_PLAN={fi_PLAN}
                            fi_SERVICIO={fi_SERVICIO}
                        />
                    </Modal>
            }
        </>
    )
}

export default General2PlanCardMol
